import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { Button, ContentTopBar } from 'components';
import {
  PackageFilterFormPaginated,
  PackageFilterFormValues,
} from 'features/package/components/package-filter-form/type';
import { useGetBookingReportList } from 'features/report-master/booking-calculation/use-cases/get-booking-calculation';
import { PackageMasterViewModal } from 'features/report-master/package-master/components/modal/packagemasterModal';
import { PackageMasterViewTable } from 'features/report-master/package-master/components/table/package-table';
import { usePaginationParams } from 'hooks';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

const initialFilterValues: PackageFilterFormValues = {
  type_id: undefined,
  name: undefined,
  company_id: undefined,
};
const { useBreakpoint } = Grid;

export const PackageMasterView = () => {
  const screens = useBreakpoint();
  const [showAddUserModal, setShowAddUserModal] = useState(false);

  const { params, updateParams } =
    usePaginationParams<PackageFilterFormPaginated>({
      page: 1,
      size: 10,
      ...initialFilterValues,
    });
  const { data, isFetching } = useGetBookingReportList(params, {
    retry: false,
  });

  return (
    <>
      <ContentTopBar
        title={'Package Report Rule'}
        renderButtons={
          <>
            <Button
              icon={!screens.xs ? <PlusOutlined /> : undefined}
              onClick={() => setShowAddUserModal(true)}
            >
              {'Add'}
            </Button>
            {showAddUserModal && (
              <PackageMasterViewModal
                onClose={() => setShowAddUserModal(false)}
              />
            )}
          </>
        }
      />
      <PackageMasterViewTable
        isLoading={isFetching}
        data={data}
        tableParams={params}
        updateParams={updateParams}
      />

      <Outlet />
    </>
  );
};
